// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1266":"2f24817d","9231":"aec3654d"}[chunkId] + ".chunk.css";
};